import angular from 'angular';
import directivesSimple from './directives-simple';

let DirectivesModule = angular.module('app.shared.directives', [])
  .directive('compareTo', directivesSimple.compareTo)
  .directive('upperCase', directivesSimple.upperCase)
  .directive('providerSideMenu', directivesSimple.providerSideMenu)
  .directive('toolboxFilter', directivesSimple.toolboxFilter)
  .directive('toolboxPagination', directivesSimple.toolboxPagination)
  .directive('ngEnter', directivesSimple.ngEnter)
  .directive('onlyLettersInput', directivesSimple.onlyLettersInput)
  .directive('onlyNumbersInput', directivesSimple.onlyNumbersInput)
  .directive('currencyFormat', directivesSimple.currencyFormat)
  .directive('checkStrength', directivesSimple.checkStrength);

export default DirectivesModule;



/** WEBPACK FOOTER **
 ** ./www/components/shared/directives/directives.js
 **/